import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import Spinner from "@/components/Spinner";

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading) {
    return (
      <div className="min-h-screen grid place-items-center">
        <Spinner size="l" label="Cargando sesión…" />
      </div>
    );
  }
  if (!user) {
    return <Navigate to="/landing" replace state={{ from: location.pathname }} />;
  }
  return children;
}
